import eventview from './eventview'
import eventform from './eventform'

const addevent = eventview.concat(eventform);

export default addevent



// WEBPACK FOOTER //
// ./src/i18n/cs/addevent/_addevent.js